// Contract Management Constants

export const TABLE_HEAD = [
  { id: 'practice_name', label: 'Practice Name', alignRight: false },
  { id: 'covered_entity', label: 'Covered Entity', alignRight: false },
  { id: 'activation_date', label: 'Activation Date', alignRight: false },
  { id: 'services', label: 'Services', alignRight: false },
  { id: 'created_on', label: 'Created On', alignRight: false },
  { id: 'status', label: 'Status', alignRight: false },
  { id: '' },
];

export const CONTRACT_STATUS_COLORS = {
  Created: 'warning.main',
  Signed: 'success.main',
  default: 'text.primary',
};

export const ROWS_PER_PAGE_OPTIONS = [10, 15, 25];

export const DEFAULT_ROWS_PER_PAGE = 15;
